import React, { useCallback } from "react";
import "./ImageCellFullModal.css";
//import { useDeviceDetection } from "../../hooks/useDeviceDetection.js";
import { formatTypoloText } from "../../utils/formatTypoloText.js";
import { X } from "lucide-react";
//import { X, MapPinHouse, Skull } from "lucide-react";
//import { IoSkull } from "react-icons/io5";
//import { FaSkullCrossbones } from "react-icons/fa6";
import { FaSkullCrossbones } from "react-icons/fa6";
import {  TbMapSearch } from "react-icons/tb";

const ImageCellFullInfo = ({ img, onOpenStreetView }) => {
  //const { isPortrait } = useDeviceDetection();
  const { isPortrait } = true;
  const gotoSV = useCallback(
    (evt) => {
      evt.stopPropagation();
      if (!img.hasCoords) return;
      /*window.open(img.streetViewUrl, "_blank", "noopener,noreferrer");*/
      onOpenStreetView?.({
        coords: img.coords,
        id: img.id,
        nyme: img.nyme,
        adress: img.adress,
        bgColor: img.bgColor,
        typoloColor: img.typoloColor,
        heading: 0,
        pitch: 0,
        zoom: 1,
      });
    },
    [img,onOpenStreetView]
  );

  const noClick = useCallback(
    (evt) => {
      evt.stopPropagation();
    },
    []
  );

  return (
    <>
      {" "}
      <div
        className={`image-full-info ${isPortrait ? "portrait" : "landscape"}`}
         onClick={noClick}
      >
        <div className="image-full-info-inner">
          <div
            className="info-block"
            style={{ backgroundColor: img.typoloColor }}
          >
            <strong>{img.nyme}</strong>
          </div>

          <div
            className="info-block"
            //style={{ backgroundColor: img.bgColor }}
          >
            <strong>{img.adress}</strong>
          </div>

          <div
            className="info-block"
            style={{ backgroundColor: img.typoloColor }}
          >
            {formatTypoloText(img.typoloA)}
          </div>

          {img.typoloB && (
            <div
              className="info-block"
              style={{ backgroundColor: img.typoloColorB }}
            >
              {formatTypoloText(img.typoloB)}
            </div>
          )}

          {img.date && (
            <div
              className="info-block"
              //style={{ backgroundColor: img.bgColor }}
            >
              <strong>{img.date}</strong>
            </div>
          )}
          
          {img.statut === "x" && (
            <div
              className="info-block"
              style={{ backgroundColor:"#000" }}
            >
              {/*<Skull size={16} strokeWidth={2} />*/}
              <FaSkullCrossbones size={16} strokeWidth={2} />
            </div>
          )}

          <div
            className="info-block"
            style={{ backgroundColor: img.typoloColor }}
          >
            <div className="gotoSV-btn" onClick={gotoSV}>
              <TbMapSearch size={16} strokeWidth={2} />
              street view
            </div>
          </div>

          {img.note && (
            <div
              className="info-block"
              style={{ backgroundColor: img.bgColor }}
            >
              <strong>{img.note}</strong>
            </div>
          )}
        </div>
      </div>
      {/* Icône X positionnée en haut à droite */}
      <div className="image-full-close">
        <X size={24} strokeWidth={2} />
      </div>
    </>
  );
};

export default ImageCellFullInfo;
